import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="transparent"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M9 13H15M12 10V16M3 17.7143V6.28571C3 5.02335 3.89543 4 5 4H11L13 6.28571H19C20.1046 6.28571 21 7.30906 21 8.57143V17.7143C21 18.9767 20.1046 20 19 20H5C3.89543 20 3 18.9767 3 17.7143Z" />
  </svg>
);
